import type { ReactNode } from 'react';

import { Text } from '@entur/typography/beta';

type KbdProps = {
  children: ReactNode;
};

export const Kbd = ({ children }: KbdProps) => (
  <Text as="kbd" variant="code-text">
    {children}
  </Text>
);

export const Plus = () => <span style={{ margin: '0 0.25rem' }}>+</span>;
